import React from "react";
import { Box } from "@mui/material";

const PUBLIC = process.env.PUBLIC_URL || "";

/** Same asset as `/prototype/mobile/jigsaw/feature-graphic`. */
export const FEATURE_GRAPHIC_ART = `${PUBLIC}/ad/jigsaw-muse-feature-graphic-1024x500.png`;

/**
 * 1080p ending capture — full viewport, feature graphic fills the frame (object-fit: cover).
 * Open in a 1920×1080 popup from PrototypeMain.
 */
export default function FeatureGraphicEndingPage() {
    return (
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                width: "100%",
                height: "100%",
                margin: 0,
                bgcolor: "#1a1028",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                boxSizing: "border-box",
            }}
        >
            <Box
                component="img"
                src={FEATURE_GRAPHIC_ART}
                alt="Jigsaw Muse feature graphic"
                sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                    display: "block",
                    userSelect: "none",
                    pointerEvents: "none",
                }}
            />
        </Box>
    );
}
